'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import CloseIcon from '@/assets/svg/close.svg';
import styles from './Modal.module.css';
interface ModalProps {
  isVisible: boolean;
  setIsVisible?: (isVisible: boolean) => void;
  onClose?: () => void;
  title?: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
  displayCloseButton?: boolean;
  className?: string;
  containerClassName?: string;
  width?: number;
  testID?: string;
}
const Modal: React.FC<ModalProps> = t0 => {
  const $ = _c(34);
  const {
    isVisible,
    setIsVisible,
    onClose,
    title,
    content,
    footer,
    displayCloseButton,
    className,
    containerClassName,
    width,
    testID
  } = t0;
  if (!isVisible) {
    return null;
  }
  let t1;
  if ($[0] !== onClose || $[1] !== setIsVisible) {
    t1 = () => {
      setIsVisible?.(false);
      onClose?.();
    };
    $[0] = onClose;
    $[1] = setIsVisible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClose = t1;
  const t2 = `${styles.backdrop} ${className ?? ""}`;
  let t3;
  if ($[3] !== handleClose) {
    t3 = e => e.key === "Escape" && handleClose();
    $[3] = handleClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleClose || $[6] !== t3) {
    t4 = <button type="button" data-testid="modal-backdrop" className={styles.backdropHitArea} onClick={handleClose} onKeyDown={t3} aria-label="Close modal" />;
    $[5] = handleClose;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `${styles.container} ${containerClassName ?? ""}`;
  let t6;
  if ($[8] !== width) {
    t6 = width ? {
      width,
      maxWidth: width
    } : undefined;
    $[8] = width;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleClose) {
    t7 = e_1 => {
      if (e_1.key === "Escape") {
        e_1.preventDefault();
        handleClose();
      } else {
        e_1.stopPropagation();
      }
    };
    $[10] = handleClose;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== displayCloseButton || $[13] !== handleClose) {
    t8 = displayCloseButton && <button type="button" data-testid="close-button" onClick={handleClose} className={styles.closeButton} aria-label="Close"><Image src={CloseIcon} aria-hidden="true" width={24} height={24} alt="" unoptimized={true} /></button>;
    $[12] = displayCloseButton;
    $[13] = handleClose;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== title) {
    t9 = title && <div className={styles.header}><h3>{title}</h3></div>;
    $[15] = title;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== content) {
    t10 = <div className={styles.content}>{content}</div>;
    $[17] = content;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== footer) {
    t11 = footer && <div className={styles.footer}>{footer}</div>;
    $[19] = footer;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9 || $[28] !== testID) {
    t12 = <dialog data-testid={testID} aria-modal="true" open={true} className={t5} style={t6} onClick={_temp} onKeyDown={t7}>{t8}{t9}{t10}{t11}</dialog>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = testID;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t2 || $[32] !== t4) {
    t13 = <div role="presentation" className={t2}>{t4}{t12}</div>;
    $[30] = t12;
    $[31] = t2;
    $[32] = t4;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default Modal;
function _temp(e_0) {
  return e_0.stopPropagation();
}